<template>
<footer class="footer-wrapper">
  <div class="footer-content">
    <div class="content-links-wrapper">
      <div class="footer-links-content">
        <a href="/" class="anchor-link">
          <img src="../src/assets/duome-logo-whitelogo.svg" >
        </a>
        <a href="/hybrid-teams" class="anchor-link">
          <h2 class="footer-label-big">For Hybrid Teams</h2>
        </a>
        <a href="/job-share" class="anchor-link">
          <h2 class="footer-label-big">For Job Shares</h2>
        </a>
      </div>
      <div class="footer-links-grid">
        <div class="footer-links-grid-list">
          <a href="/about-us" class="grid-anchor-link">Company</a>
          <a href="/blog" class="grid-anchor-link">Blog</a>
          <a href="/flexible-jobs" class="grid-anchor-link">Flexible Jobs</a>
        </div>
        <div class="footer-links-grid-list">
          <a href="/privacy-policy" target="_blank" class="grid-anchor-link">Legal</a>
          <a href="https://duome.statuspage.io/" target="_blank" class="grid-anchor-link">Status</a>
        </div>
      </div>
    </div>
    <div class="social-media-footer">
      <div class="copyright-label">Copyright © DuoMe 2022<br> </div>
      <div class="social-media-icons">
        <a href="https://twitter.com/duomeco" target="_blank" class="social-media-anchor-link">
          <img src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/604206385c05bf82ea0f1111_twitter.svg" alt="" class="icon-link">
        </a>
        <a href="https://www.linkedin.com/company/duome/" target="_blank" class="social-media-anchor-link">
          <img src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/605a1705d9ff11814e727285_linkedin%201.svg" alt="" class="icon-link">
        </a>
        <a href="https://www.facebook.com/duomeco" target="_blank" class="social-media-anchor-link">
          <img src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/604206385c05bf96ed0f1106_facebook.svg" alt="" class="icon-link">
        </a>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style>
.footer-wrapper {
  position: relative;
  overflow: hidden;
  padding-top: 96px;
  padding-bottom: 48px;
  background-color: #141414;
  color: #fff;
  box-sizing: border-box;
  height: 100%;
}
.footer-wrapper .footer-content {
  position: relative;
  display: block;
  max-width: 1296px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
  text-align: center;
}
.footer-content .content-links-wrapper {
  display: flex;
  justify-content: space-between;
}
.content-links-wrapper .footer-links-content {
  display: flex;
  margin-right: 121px;
  flex-direction: column;
}
.footer-links-content .anchor-link {
  color: #fff;
  max-width: 100%;
  display: inline-block;
  background-color: transparent;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;
}
.footer-links-content .anchor-link img {
  border: 0;
  vertical-align: middle;
  display: inline-block;
  max-width: 100%;
  max-height: 40px;
  margin-bottom: 18px;
  margin-left: 1px;
  align-self: flex-start;
  text-align: left;
  width: 100%;
}
.footer-links-content .anchor-link .footer-label-big {
  margin-bottom: 12px;
  font-family: Lato,sans-serif;
  color: #fff;
  margin-top: 0;
  margin-bottom: 24px;
  font-family: 'Space Grotesk',sans-serif;
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
}
.content-links-wrapper .footer-links-grid {
  display: grid;
  align-self: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-areas: ".";
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
}
.footer-links-grid  .footer-links-grid-list {
  display: flex;
  min-width: 144px;
  flex-direction: column;
}
.footer-links-grid-list .grid-anchor-link {
  margin-bottom: 6px;
  transition: color .2s;
  color: #fff;
  text-decoration: none;
}
.footer-content .social-media-footer {
  display: flex;
  margin-top: 30px;
  padding: 0 64px;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Nunito Sans',sans-serif;
}
.social-media-footer .copyright-label {
  font-size: 14px;
  line-height: 22px;
  padding-top: 9px;
  color: #fff;
}
.social-media-icons .social-media-anchor-link {
  max-width: 100%;
  display: inline-block;
  background-color: transparent;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.social-media-anchor-link .icon-link {
  width: 18px;
  height: 18px;
  margin-right: 12px;
  border: 0;
  vertical-align: middle;
  display: inline-block;
  max-width: 100%;
}
@media screen and (max-width: 991px) {
  .footer-wrapper {
    padding-top: 72px;
  }
  .footer-wrapper .footer-content {
    padding-right: 25px;
    padding-left: 25px;
  }
  .footer-content .content-links-wrapper {
    align-items: center;
    width: 100%;
    justify-content: space-around;
  }
  .content-links-wrapper .footer-links-content {
    margin-right: 96px;
  }
  .content-links-wrapper .footer-links-grid {
    grid-column-gap: 24px;
    grid-row-gap: 48px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }
  .footer-content .social-media-footer {
    display: flex;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
  .social-media-footer .social-media-icons {
    margin-top: 24px;
  }
}

@media screen and (max-width: 767px) {
  .footer-wrapper {
    overflow: hidden;
    padding-top: 48px;
  }
  .footer-content .content-links-wrapper {
    flex-direction: column;
  }
  .content-links-wrapper .footer-links-content {
    margin-right: auto;
    margin-bottom: 40px;
    margin-left: auto;
    align-items: center;
  }
  .content-links-wrapper .footer-links-grid {
    display: flex;
    justify-content: center;
    justify-items: center;
    grid-template-columns: 1fr;
  }
  .footer-links-grid  .footer-links-grid-list {
    align-items: center;
  }
}
</style>